<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :apiUrl="apiUrl">

      <template #additionalButton="scope">
<!--             
        <button
          class="btn btn-sm btn-primary"
          :disabled="!selectedItem ? true : selectedItem.Active !== 0"
          v-b-tooltip.hover
          title="Connect Mesin"
          @click="connectMachine"
          v-b-toggle.collapse-filter>
          <i class="fas fa-play-circle"></i>
          <span class="d-none d-lg-inline-block ml-1">Connect Mesin</span>
        </button>
-->
        <button
          class="btn btn-sm btn-info"
          v-if="!withoutFormManualCapture"
          v-b-tooltip.hover
          title="Tarik Data Manual"
          :disabled="isLoading || !selectedItem"
          @click="modalManualCapture">
          <i class="fas fa-history"></i>
          <span class="d-none d-lg-inline-block ml-1">Tarik Data Manual</span>
          <div class="spinner-border" role="status" v-show="isLoading">
            <span class="sr-only">Loading...</span>
          </div>
        </button>

        <button
          class="btn btn-sm btn-warning"
          v-b-tooltip.hover
          title="Reconnect Mesin"
          :disabled="isLoading"
          @click="reconnectAllMachine">
          <i class="fas fa-history"></i>
          <span class="d-none d-lg-inline-block ml-1">Reconnect Mesin</span>
          <div class="spinner-border" role="status" v-show="isLoading">
            <span class="sr-only">Loading...</span>
          </div>
        </button>

      </template>

      <template #form="scope">
        <div class="form-group">
          <label>Nama Mesin / Alias</label>
          <input class="form-control d-block w-100" v-model="scope.data.Name">
        </div>

        <div class="form-group">
          <label>IP Address</label>
          <input class="form-control d-block w-100" v-model="scope.data.IPAddress">
        </div>

        <div class="form-group">
          <label>Port</label>
          <input class="form-control d-block w-100" v-model.number="scope.data.Port">
        </div>

        <div class="form-group">
          <label>Key</label>
          <input class="form-control d-block w-100" v-model="scope.data.Key">
        </div>

<!-- 
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" v-model="scope.data.Active">
          <label class="custom-control-label">Aktif ?</label>
        </div>
-->    

        <div class="form-group">
          <label>Instansi</label>
          <v-select
            v-model="scope.data.CompanyID"
            :options="listCompanies"
            :reduce="item => item.ID"
            label="Name"/>
        </div>

        <button class="btn btn-primary btn-sm btn-block" type="submit">Simpan</button>
      </template>

    </AppToolbox>

    <AppTable :apiUrl="apiUrl" :fields="tableFields" :search="search" @onSelectItem="selectedItem = $event" />
    

    <b-modal
      id="modalManualCapture"
      v-if="!withoutFormManualCapture"
      title="Formulir Tarik Data Manual"
      header-class="bg-light text-primary py-1"
      no-close-on-backdrop
      hide-footer>

      <form @submit.prevent="submitManualCapture" class="d-block">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Tanggal Awal</label>
              <b-form-datepicker v-model="formCapture.startDate" size="sm" locale="id" />
            </div>

            <div class="form-group">
              <label>Jam Awal</label>
              <b-form-timepicker v-model="formCapture.startTime" size="sm" locale="id" />
            </div>
          </div>

          <div class="col">
            <div class="form-group">

              <label>Tanggal Akhir</label>
              <b-form-datepicker v-model="formCapture.endDate" size="sm" locale="id" />
            </div>

            <div class="form-group">
              <label>Jam Akhir</label>
              <b-form-timepicker v-model="formCapture.endTime" size="sm" locale="id" />
            </div>
          </div>
        </div>
        
        <button :disabled="!onSubmitManualCapture" class="btn btn-primary btn-sm btn-block" type="submit">Simpan</button>
      </form>
    </b-modal>
    
  </div>
</template>

<script>
// import axios from 'axios'

import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  props: {
    selectedItem: Object,
  },
  components: { AppToolbox, AppTable },
  mounted() {
    this.onRefresh()
    this.loadOptionData()

    this.formCapture.startDate = this.$helper.dateToYMD(new Date())
    this.formCapture.endDate = this.$helper.dateToYMD(new Date())
  },
  data() {
    return {
      apiUrl: '/machine',
      tableRef: 'tableMenu',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Nama Mesin' },
        { key: 'IPAddress', label: 'IP Address' },
        { key: 'Port', label: 'Port' },
        { key: 'Key', label: 'Key' },
        { key: 'Active', label: 'Aktif', formatter: value => {
          if (value === 1) {
            return '<span class="badge badge-success">Iya</span>'
          } else {
            return '<span class="badge badge-danger">Tidak</span>'
          }
        }},
        { key: 'Company', label: 'Instansi', formatter: value => this.$helper.textToTitleCase(value.Name) }
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {
        ID: null,
        Name: '',
        IPAddress: '',
        Port: null,
        Key: '',
        Active: null,
        CompanyID: ''
      },
      onSubmitManualCapture: true,
      formCapture: {
        startDate: '2021-01-01',
        startTime: '05:00:00',
        endDate: '2021-01-01',
        endTime: '23:59:59'
      },
      scopedDetailData: {},
      listCompanies: []
    }
  },

  computed: {
    isLoading () {
      this.$store.state.isLoading
    }
  },

  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    loadOptionData () {
      this.$axios.get('/company').then((res) => {
        this.listCompanies = res.data
      })
    },

    reconnectAllMachine () {
      // axios.get('http://103.123.65.35:3002/attendance/live_capture').then((res) => {
      this.$axios.post('/attendance/live_capture/start').then((res) => {
        this.onRefresh()

        this.$bvToast.toast('Berhasil reconnect mesin', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true
        })
      })
    },

    modalManualCapture () {
      if (this.withoutFormManualCapture) {
        return
      }

      this.onSubmitManualCapture = true
      this.$bvModal.show('modalManualCapture')
    },

    submitManualCapture (event) {
      event.preventDefault()
      this.onSubmitManualCapture = false

      if (this.manualCaptureStartDate == '' || this.manualCaptureEndDate == '') {
        this.$bvToast.toast('Mohon jam diisi', {
          title: 'Warning!!',
          variant: 'warning',
          solid: true
        })
        return
      }
      

      const data = { 
        id: this.selectedItem.ID,
        startDate: this.formCapture.startDate + ' ' + this.formCapture.startTime, 
        endDate: this.formCapture.endDate + ' ' + this.formCapture.endTime
      };
      
      this.$axios.post('/attendance/manual_capture/start', data).then((res) => {
        this.$bvModal.hide('modalManualCapture')
        this.$bvToast.toast('Berhasil tarik data manual mesin', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true
        })
        this.onSubmitManualCapture = true
      }).catch(error => {
        this.onSubmitManualCapture = true
      })
    },

    connectMachine () {
      this.$bvToast.toast('Mohon maaf', {
        title: 'Sukses!!',
        variant: 'success',
        solid: true
      })
    }
  }
}
</script>
